// src/components/FooterSection/FooterSection.jsx

import React from 'react';
import './FooterSection.css'; 

import { FaWhatsapp } from 'react-icons/fa';

const FooterSection = () => {
  return (
    <footer className="footer-compact">
      <div className="footer-main-content">
        
        <div className="footer-left">
          <a href="/" className="footer-logo-link">
            <img 
              src="/images/alzira-imperial-logo.webp"  
              alt="Logo Alzira Imperial Hotel"   
              className="footer-logo" 
            />
          </a>
          <p className="footer-tagline">Onde a sofisticação encontra o coração da cidade.</p>
        </div>

        <div className="footer-right">
          <div className="footer-links-group">
            <h4>Explore</h4>
            <ul>
              <li><a href="/#o-hotel">O Hotel</a></li>
              <li><a href="/#acomodacoes">Acomodações</a></li>
              <li><a href="/#programacao">Programação</a></li>
              <li><a href="/#sao-lourenco">São Lourenço</a></li>
            </ul>
          </div>
          <div className="footer-links-group">
            <h4>Contato</h4>
            <ul>
              {/* Informações de contato atualizadas */}
              <li><span>(35) 3332-1144</span></li>
              <li><span>Av Dom Pedro II, 593</span></li>
              <li><span>São Lourenço, MG</span></li>
              <li>
                <a href="https://wa.me/5535988171649" className="whatsapp-link" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp />
                  <span>Whatsapp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom-compact">
        <b>
          <a href="/termos-de-uso">Termos de Uso</a> &bull; <a href="/politica-de-privacidade">Política de Privacidade</a> &bull; <a href="/politica-de-cancelamento">Política de Cancelamento</a><br/>
        </b>
        <b>
          {/* Nome do hotel e CNPJ atualizados */}
          &copy; {new Date().getFullYear()} Alzira Imperial Hotel | CNPJ: 24.618.487/0001-39 | Desenvolvido por <a href="https://wa.me/5535991325223">Albano</a>
        </b>
      </div>
    </footer>
  );
};

export default FooterSection;